module.exports = __webpack_public_path__ + "img/img_back_black.0da0996f.png";